import React from 'react';
import TableText from '../../TableText';
import _ from 'lodash';
import moment from 'moment';
import { calculation, sum, numConvert } from '@/method';

const TOTALINDEX = [];
const PERCENTINDEX = [2, 4, 6, 13];

export default (data, dataLast) => {
    const listName = ['actual', 'forecast', 'budget', 'last', 'ytdActual', 'ytdBudget', 'ytdLast', 'threeActual', 'threeBudget', 'threeLast', 'wholeActual', 'wholeBudget', 'wholeLast'];

    // 计算年度累计
    data[7].ytdBudget = sum([
        _.get(dataLast, `7.ytdBudget`, 0),
        data[7].budget
    ]);
    data[8].ytdBudget = sum([
        _.get(dataLast, `8.ytdBudget`, 0),
        data[8].budget
    ]);

    listName.forEach(name => {
        data[2][name] = calculation(data[1][name], data[0][name], 4);
        data[4][name] = calculation(data[3][name], data[0][name], 4);
        data[6][name] = calculation(data[5][name], data[0][name], 4);
        data[9][name] = sum([data[8][name], data[7][name]]);
        data[12][name] = sum([data[11][name], data[10][name]]);
        data[14][name] = calculation(data[0][name], data[7][name], 4);
        data[15][name] = calculation(data[0][name], data[9][name], 4);
    });

    // 计算chang变化百分比
    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        data[i].actVsFcst = calculation(item.actual, item.forecast, 4);
        data[i].actVsBgt = calculation(item.actual, item.budget, 4);
        data[i].actVsLy = calculation(item.actual, item.last, 4);
        data[i].ytdActVsBgt = calculation(item.ytdActual, item.ytdBudget, 4);
        data[i].ytdActVsLy = calculation(item.ytdActual, item.ytdLast, 4);
        data[i].threeActVsLy = calculation(item.threeActual, item.threeLast, 4);
        data[i].threeActVsBgt = calculation(item.threeActual, item.threeBudget, 4);
        data[i].wholeActVsLy = calculation(item.wholeActual, item.wholeLast, 4);
        data[i].wholeActVsBgt = calculation(item.wholeActual, item.wholeBudget, 4);
    }
    return data
}

export const fillData = (data, dataAll, date) => {
    // 从1.1获取数据,只在获取数据时填充
    const correspond = {
        actual: 'actual',
        forecast: "prediction",
        budget: "budget",
        last: "last_year",
        ytdActual: "year_actual",
        ytdBudget: "year_budget",
        ytdLast: "year_last_year",
        threeActual: "three_actual",
        threeBudget: "three_budget",
        threeLast: "three_last_year",
        wholeActual: "whole_actual",
        wholeBudget: "whole_budget",
        wholeLast: "whole_last_year",
    };
    Object.keys(correspond).forEach(name => {
        data[0][name] = _.get(dataAll, `data1.6.${correspond[name]}`, 0);
        data[1][name] = _.get(dataAll, `data1.11.${correspond[name]}`, 0);
        data[13][name] = calculation(
            _.get(dataAll, `data1.6.${correspond[name]}`, 0),
            _.get(dataAll, `data1.8.${correspond[name]}`, 0),
            4
        );
    });

    data[7].actual = _.get(dataAll, `data7_7.9.actual`, 0);
    data[7].last = _.get(dataAll, `data7_7.9.last`, 0);
    data[10].actual = _.get(dataAll, `data7_7.11.actual`, 0);
    data[10].last = _.get(dataAll, `data7_7.11.last`, 0);

    data[8].actual = _.get(dataAll, `data7_1.17.thisy_employee_num`, 0);
    data[8].last = _.get(dataAll, `data7_1.17.lasty_employee_num`, 0);
    data[8].ytdActual = _.get(dataAll, `data7_1.17.year_thisy_employee_num`, 0);
    data[8].ytdLast = _.get(dataAll, `data7_1.17.year_lasty_employee_num`, 0);
    data[11].actual = _.get(dataAll, `data7_1.17.thisy_payroll_cost`, 0);
    data[11].last = _.get(dataAll, `data7_1.17.lasty_payroll_cost`, 0);

    data[7].ytdActual = _.get(dataAll, `data7_8.35.now_year`, 0);
    data[7].ytdLast = _.get(dataAll, `data7_8.35.last_year`, 0);
    data[10].ytdActual = _.get(dataAll, `data7_8.37.now_year`, 0);
    data[10].ytdLast = _.get(dataAll, `data7_8.37.last_year`, 0);
    data[11].ytdActual = _.get(dataAll, `data7_8.66.now_year`, 0);
    data[11].ytdLast = _.get(dataAll, `data7_8.66.last_year`, 0);

    const listName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = listName[moment(date).format("M") - 1];
    data[7].budget = _.get(dataAll, `data16_1.6.number`, 0);
    data[10].budget = _.get(dataAll, `data16_1.11.${month}`, 0);

    return data;
}

export const columns = ({ print, onChange }) => {
    return [
        // {
        //     title: 'key',
        //     dataIndex: 'sort',
        //     key: 'sort',
        //     align: "center",
        //     fixed: !print && "left",
        // },
        {
            title: 'Key Performance Indicator 关键绩效指数',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: !print && "left",
            width: 500,
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'text', name: "name", onChange, totalIndex: TOTALINDEX,
                };
                return <TableText data={{ ...props }} />
            }
        }, {
            title: 'MTD 月累计',
            children: [{
                title: 'Actual 实际',
                dataIndex: 'actual',
                key: 'actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 16].includes(index) && !print ? 'inputNumber' : "number", name: "actual", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Actual 实际'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Forecast 预测',
                dataIndex: 'forecast',
                key: 'forecast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "forecast", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Forecast 预测'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Budget 预算',
                dataIndex: 'budget',
                key: 'budget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 8, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "budget", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Budget 预算'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Last Year 去年',
                dataIndex: 'last',
                key: 'last',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 16].includes(index) && !print ? 'inputNumber' : "number", name: "last", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Last Year 去年'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: '% Change 变化百分比',
                children: [{
                    title: 'Act vs. Fcst. 实际对比预测',
                    dataIndex: 'actVsFcst',
                    key: 'actVsFcst',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "actVsFcst", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['MTD 月累计', '% Change 变化百分比', 'Act vs. Fcst. 实际对比预测'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: 'Act vs. Bgt. 实际对比预算',
                    dataIndex: 'actVsBgt',
                    key: 'actVsBgt',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "actVsBgt", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['MTD 月累计', '% Change 变化百分比', 'Act vs. Bgt. 实际对比预算'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: 'Act vs. LY 实际对比去年',
                    dataIndex: 'actVsLy',
                    key: 'actVsLy',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "actVsLy", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['MTD 月累计', '% Change 变化百分比', 'Act vs. LY 实际对比去年'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }]
            }]
        }, {
            title: 'YTD 年累计',
            children: [{
                title: 'Actual 实际',
                dataIndex: 'ytdActual',
                key: 'ytdActual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 16].includes(index) && !print ? 'inputNumber' : "number", name: "ytdActual", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['YTD 年累计', 'Actual 实际'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Budget 预算',
                dataIndex: 'ytdBudget',
                key: 'ytdBudget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "ytdBudget", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['YTD 年累计', 'Budget 预算'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Last Year 去年',
                dataIndex: 'ytdLast',
                key: 'ytdLast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 16].includes(index) && !print ? 'inputNumber' : "number", name: "ytdLast", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['YTD 年累计', 'Last Year 去年'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: '% Change 变化百分比',
                children: [{
                    title: 'Act vs. Bgt. 实际对比预算',
                    dataIndex: 'ytdActVsBgt',
                    key: 'ytdActVsBgt',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "ytdActVsBgt", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['YTD 年累计', '% Change 变化百分比', 'Act vs. Bgt. 实际对比预算'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: 'Act vs. LY 实际对比去年',
                    dataIndex: 'ytdActVsLy',
                    key: 'ytdActVsLy',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "ytdActVsLy", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['YTD 年累计', '% Change 变化百分比', 'Act vs. LY 实际对比去年'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }]
            }]
        }, {
            title: '3-Month-Rolling Forecast 后三个月滚动预测',
            children: [{
                title: 'Actual 实际',
                dataIndex: 'threeActual',
                key: 'threeActual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "threeActual", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['3-Month-Rolling Forecast 后三个月滚动预测', 'Actual 实际'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Budget 预算',
                dataIndex: 'threeBudget',
                key: 'threeBudget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "threeBudget", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['3-Month-Rolling Forecast 后三个月滚动预测', 'Budget 预算'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Last Year 去年',
                dataIndex: 'threeLast',
                key: 'threeLast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "threeLast", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['3-Month-Rolling Forecast 后三个月滚动预测', 'Last Year 去年'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: '% Change 变化百分比',
                children: [{
                    title: 'Act vs. Bgt. 实际对比预算',
                    dataIndex: 'threeActVsLy',
                    key: 'threeActVsLy',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "threeActVsLy", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['3-Month-Rolling Forecast 后三个月滚动预测', '% Change 变化百分比', 'Act vs. Bgt. 实际对比预算'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: 'Act vs. LY 实际对比去年',
                    dataIndex: 'threeActVsBgt',
                    key: 'threeActVsBgt',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "threeActVsBgt", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['3-Month-Rolling Forecast 后三个月滚动预测', '% Change 变化百分比', 'Act vs. LY 实际对比去年'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }]
            }]
        }, {
            title: 'Whole Year Forecast Total 整年预测',
            children: [{
                title: 'Actual 实际',
                dataIndex: 'wholeActual',
                key: 'wholeActual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "wholeActual", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Actual 实际'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Budget 预算',
                dataIndex: 'wholeBudget',
                key: 'wholeBudget',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "wholeBudget", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Budget 预算'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'Last Year 去年',
                dataIndex: 'wholeLast',
                key: 'wholeLast',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: PERCENTINDEX.includes(index) ? 'percent' : [3, 5, 7, 8, 10, 11, 16].includes(index) && !print ? 'inputNumber' : "number", name: "wholeLast", onChange, totalIndex: TOTALINDEX,
                        compared: {
                            title: ['MTD 月累计', 'Last Year 去年'],
                            record,
                            sqlName: "_5"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: '% Change 变化百分比',
                children: [{
                    title: 'Act vs. Bgt. 实际对比预算',
                    dataIndex: 'wholeActVsBgt',
                    key: 'wholeActVsBgt',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "wholeActVsBgt", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['MTD 月累计', '% Change 变化百分比', 'Act vs. Bgt. 实际对比预算'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }, {
                    title: 'Act vs. LY 实际对比去年',
                    dataIndex: 'wholeActVsLy',
                    key: 'wholeActVsLy',
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: "percent", name: "wholeActVsLy", onChange, totalIndex: TOTALINDEX,
                            compared: {
                                title: ['MTD 月累计', '% Change 变化百分比', 'Act vs. LY 实际对比去年'],
                                record,
                                sqlName: "_5"
                            }
                        };
                        return <TableText data={{ ...props }} />
                    }
                }]
            }]
        }]
}


// WEBPACK FOOTER //
// ./src/components/table/5.0/5/compute.js